import { render, staticRenderFns } from "./Workstations.vue?vue&type=template&id=64630dea&"
import script from "./Workstations.vue?vue&type=script&lang=js&"
export * from "./Workstations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports